// extracted by mini-css-extract-plugin
export default {"root":"OffersIntro-root_md6oO","icon":"OffersIntro-icon_huaTG"};